import { render, staticRenderFns } from "./MarketCategoryView.vue?vue&type=template&id=9ad45d96"
import script from "./MarketCategoryView.vue?vue&type=script&lang=js"
export * from "./MarketCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports